<div
    class="visibility-top"
    (visibilityNotifier)="scrollTopButton = false"
    (invisibilityNotifier)="scrollTopButton = true"
></div>
<div fxLayout="column">
    <div *ngFor="let item of data">
        <div
            *ngIf="item?.layoutType === '1-col-extra-offer-strip-banner'"
            class="offer-extra-container"
            [ngStyle.xs]="{ paddingTop: '0%' }"
            (click)="
                item?.layoutContent?.banner.link.includes('http://')
                    ? externalLinksRedirect(item?.layoutContent?.banner.link)
                    : processLink(item?.layoutContent?.banner.link)
            "
        >
            <picture
                class="offer-extra-strip"
                *ngIf="!item?.layoutContent?.banner?.video"
                [ngClass]="{ 'image-offer-shimmer': showShimmer }"
            >
                <img
                    class="offer-extra-strip__image"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>
            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{ item?.layoutContent?.banner?.image }}"
                style="
                    border: none;
                    position: absolute;
                    top: 0;
                    height: auto;
                    width: 100%;
                "
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
                preload="auto"
            >
                <source
                    src="{{
                        item?.layoutContent?.banner?.video +
                            this.mediaCDN.getVideoCDN()
                    }}"
                    type="video/webm"
                />
                <source
                    [src]="
                        homepageService.convertWebToMp4(
                            item?.layoutContent?.banner?.video
                        )
                    "
                    type="video/mp4"
                />
            </video>
        </div>
        <div
            *ngIf="
                item?.layoutType ===
                '1-col-extra-offer-strip-banner-without-padding'
            "
            class="offer-extra-container"
            [ngStyle.xs]="{ paddingTop: '0%' }"
            (click)="
                item?.layoutContent?.banner.link.includes('http://')
                    ? externalLinksRedirect(item?.layoutContent?.banner.link)
                    : processLink(item?.layoutContent?.banner.link)
            "
        >
            <picture
                class="offer-extra-strip"
                *ngIf="!item?.layoutContent?.banner?.video"
                [ngClass]="{ 'image-offer-shimmer': showShimmer }"
            >
                <img
                    class="offer-extra-strip__image"
                    style="margin: -4px 0px"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>
            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{ item?.layoutContent?.banner?.image }}"
                style="
                    border: none;
                    position: absolute;
                    top: 0;
                    height: auto;
                    width: 100%;
                "
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
                preload="auto"
            >
                <source
                    src="{{
                        item?.layoutContent?.banner?.video +
                            this.mediaCDN.getVideoCDN()
                    }}"
                    type="video/webm"
                />
                <source
                    [src]="
                        homepageService.convertWebToMp4(
                            item?.layoutContent?.banner?.video
                        )
                    "
                    type="video/mp4"
                />
            </video>
        </div>
        <div
            *ngIf="item?.layoutType === '1-col-medium-strip-banner'"
            class="medium-extra-container"
            (click)="
                item?.layoutContent?.banner.link.includes('http://')
                    ? externalLinksRedirect(item?.layoutContent?.banner.link)
                    : processLink(item?.layoutContent?.banner.link)
            "
            [ngStyle]="getStyles(this.item?.layoutContent?.padding)"
        >
            <picture
                class="medium-extra-strip"
                *ngIf="!item?.layoutContent?.banner?.video"
                [ngStyle]="{
                    cursor: item?.layoutContent?.banner?.link
                        ? 'pointer'
                        : 'auto'
                }"
                [ngClass]="{ 'image-offer-shimmer': showShimmer }"
            >
                <img
                    class="medium-extra-strip__image"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>
            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{ item?.layoutContent?.banner?.image }}"
                style="border: none; top: 0; height: auto; width: 100%"
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
                preload="auto"
            >
                <source
                    src="{{
                        item?.layoutContent?.banner?.video +
                            this.mediaCDN.getVideoCDN()
                    }}"
                    type="video/webm"
                />
                <source
                    [src]="
                        homepageService.convertWebToMp4(
                            item?.layoutContent?.banner?.video
                        )
                    "
                    type="video/mp4"
                />
            </video>
            <div
                *ngIf="!!item?.layoutContent?.button?.link"
                class="medium-strip__text-button"
                ngClass.xs="medium-strip__text-button-mobile"
                fxLayout="column"
                fxLayout.xs="column"
                fxLayoutAlign="center center"
            >
                <div
                    class="medium-strip__container"
                    ngClass.lt-md="medium-strip__container-mobile"
                >
                    <h1
                        class="medium-strip__text-header"
                        style="color:{{ item?.layoutContent?.title?.color }}"
                        [ngStyle.lt-md]="{
                            fontSize: '23px',
                            paddingTop: '7px',
                            textAlign: 'center'
                        }"
                        >{{ item?.layoutContent?.title?.text }}</h1
                    >
                    <p
                        class="medium-strip__text-subtitle"
                        style="color:{{
                            item?.layoutContent?.subtitle?.color
                        }};white-space: pre-line"
                        [ngStyle.lt-md]="{
                            fontSize: '11px',
                            paddingTop: '6px'
                        }"
                        [ngStyle.gt-xs]="{ width: '100%' }"
                        >{{ item?.layoutContent?.subtitle?.text }}
                        <span
                            (click)="
                                processLink(item?.layoutContent?.button?.link)
                            "
                            class="medium-strip__button"
                            [ngStyle.lt-md]="{
                                top: '-38px',
                                left: '144px',
                                width: '88px'
                            }"
                            mat-raised-button
                            style="color:{{
                                item?.layoutContent?.button?.title?.color
                            }}"
                            >{{
                                item?.layoutContent?.button?.title?.text
                            }}</span
                        ></p
                    >
                </div>
            </div>
            <div #spacer fxFlex="0 1 50%" fxFlexOrder="0"></div>
        </div>
        <div
            *ngIf="item?.layoutType === 'timer-strip-v2' && isTimerStripV2"
            class="timer-strip"
            [ngStyle]="{
                paddingBottom: item?.layoutContent?.padding?.bottom + 'px',
                paddingTop: item?.layoutContent?.padding?.top + 'px'
            }"
        >
            <picture
                class="timer-extra-strip"
                [ngClass]="{ 'image-offer-shimmer': showShimmer }"
            >
                <img
                    *ngIf="item?.layoutContent?.banner?.image"
                    class="timer-extra-strip__image"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>

            <div
                [fxFlex]="homepageService.getFlex(item.layoutContent)"
                style="background-color:{{
                    item?.layoutContent?.banner?.background
                }}"
                [fxFlexOrder]="homepageService.getFlexOrder(item.layoutContent)"
                fxLayoutAlign="center center"
                fxLayout="row"
                class="timer-section"
            >
                <p></p>
                <div class="headline">
                    <h1 style="color:{{ item?.layoutContent?.title?.color }}">{{
                        item?.layoutContent?.title?.text
                    }}</h1>
                </div>
                <div class="countdown">
                    <ul style="color:{{ item?.layoutContent?.title?.color }}">
                        <li *ngIf="day >= 1"
                            ><span>{{ day | number: '2.0-0' }}</span
                            >Day</li
                        >
                        <li *ngIf="day >= 1" class="bullets">:</li>
                        <li
                            ><span>{{ hours | number: '2.0-0' }}</span
                            >Hours</li
                        >
                        <li class="bullets">:</li>
                        <li
                            ><span>{{ mins | number: '2.0-0' }}</span
                            >Minutes</li
                        >
                        <span *ngIf="day < 1">
                            <li class="bullets">:</li>
                            <li
                                ><span>{{ seconds | number: '2.0-0' }}</span
                                >Seconds</li
                            >
                        </span>
                    </ul>
                </div>
            </div>
        </div>
        <div
            *ngIf="item?.layoutType === 'timer-strip' && isTimerStrip"
            class="timer-strip"
            [ngStyle]="{
                paddingBottom: item?.layoutContent?.padding?.bottom + 'px',
                paddingTop: item?.layoutContent?.padding?.top + 'px'
            }"
        >
            <picture
                class="timer-extra-strip"
                [ngClass]="{ 'image-offer-shimmer': showShimmer }"
            >
                <img
                    *ngIf="item?.layoutContent?.banner?.image"
                    class="timer-extra-strip__image"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>

            <div
                [fxFlex]="homepageService.getFlex(item.layoutContent)"
                style="background-color:{{
                    item?.layoutContent?.banner?.background
                }}"
                [fxFlexOrder]="homepageService.getFlexOrder(item.layoutContent)"
                fxLayoutAlign="center center"
                fxLayout="row"
                class="timer-section"
            >
                <p></p>
                <div class="headline">
                    <h1 style="color:{{ item?.layoutContent?.title?.color }}">{{
                        item?.layoutContent?.title?.text
                    }}</h1>
                </div>
                <div class="countdown">
                    <ul style="color:{{ item?.layoutContent?.title?.color }}">
                        <li
                            ><span>{{ hours | number: '2.0-0' }}</span
                            >Hours</li
                        >
                        <li class="bullets">:</li>
                        <li
                            ><span>{{ mins | number: '2.0-0' }}</span
                            >Minutes</li
                        >

                        <li class="bullets">:</li>
                        <li
                            ><span>{{ seconds | number: '2.0-0' }}</span
                            >Seconds</li
                        >
                    </ul>
                </div>
            </div>
        </div>
        <div
            *ngIf="item?.layoutType === '1-col-strip-banner'"
            class="offer-container"
            [ngStyle.gt-xs]="{
                marginBottom: item?.layoutContent?.banner?.image
                    ? '4px'
                    : 'none'
            }"
            [ngStyle.xs]="{ paddingTop: '65%' }"
            (click)="
                item?.layoutContent?.banner.link.includes('http://')
                    ? externalLinksRedirect(item?.layoutContent?.banner.link)
                    : processLink(item?.layoutContent?.banner.link)
            "
        >
            <picture
                class="offer-strip"
                *ngIf="!item?.layoutContent?.banner?.video"
                [ngClass]="{ 'image-offer-shimmer': showShimmer }"
            >
                <img
                    class="offer-strip__image"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>
            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{ item?.layoutContent?.banner?.image }}"
                style="
                    border: none;
                    position: absolute;
                    top: 0;
                    height: auto;
                    width: 100%;
                "
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
                preload="auto"
            >
                <source
                    src="{{
                        item?.layoutContent?.banner?.video +
                            this.mediaCDN.getVideoCDN()
                    }}"
                    type="video/webm"
                />
                <source
                    [src]="
                        homepageService.convertWebToMp4(
                            item?.layoutContent?.banner?.video
                        )
                    "
                    type="video/mp4"
                />
            </video>
            <div
                *ngIf="!!item?.layoutContent?.button?.link"
                class="offer-strip__text-button"
                ngClass.xs="offer-strip__text-button-mobile"
                fxLayout="row"
                fxLayout.xs="column"
            >
                <div
                    class="offer-strip__container"
                    ngClass.lt-md="offer-strip__container-mobile"
                    [fxFlex]="homepageService.getFlex(item.layoutContent)"
                    [fxFlexOrder]="
                        homepageService.getFlexOrder(item.layoutContent)
                    "
                    fxLayout="column"
                    fxLayoutAlign="center flex-start"
                >
                    <h1
                        class="offer-strip__text-header"
                        style="color:{{ item?.layoutContent?.title?.color }}"
                        [ngStyle.lt-md]="{ fontSize: '18px' }"
                        >{{ item?.layoutContent?.title?.text }}</h1
                    >
                    <p
                        class="offer-strip__text-subtitle"
                        style="color:{{
                            item?.layoutContent?.subtitle?.color
                        }};white-space: pre-line"
                        [ngStyle.lt-md]="{ fontSize: '11px' }"
                        [ngStyle.gt-xs]="{ width: '150%' }"
                        >{{ item?.layoutContent?.subtitle?.text }}</p
                    >
                    <div style="border: 0.3px solid white; margin-left: 7px">
                        <button
                            class="offer-strip__button"
                            mat-raised-button
                            style="color:{{
                                item?.layoutContent?.button?.title?.color
                            }}"
                            >{{ item?.layoutContent?.button?.title?.text
                            }}<img
                                style="width: 12px; height: 12px"
                                src="{{ item?.layoutContent?.button?.icon }}"
                                appImageCDN
                                [alt]="
                                    item?.layoutContent?.title?.text || 'banner'
                                "
                        /></button>
                    </div>
                </div>
                <div #spacer fxFlex="0 1 50%" fxFlexOrder="0"></div>
            </div>
        </div>
        <div
            *ngIf="item?.layoutType === '1-col-strip-banner-without-padding'"
            class="offer-container"
            [ngStyle.xs]="{ paddingTop: '65%' }"
            (click)="
                item?.layoutContent?.banner.link.includes('http://')
                    ? externalLinksRedirect(item?.layoutContent?.banner.link)
                    : processLink(item?.layoutContent?.banner.link)
            "
        >
            <picture
                class="offer-strip"
                *ngIf="!item?.layoutContent?.banner?.video"
                [ngClass]="{ 'image-offer-shimmer': showShimmer }"
            >
                <img
                    class="offer-strip__image"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>
            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{ item?.layoutContent?.banner?.image }}"
                style="
                    border: none;
                    position: absolute;
                    top: 0;
                    height: auto;
                    width: 100%;
                "
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
                preload="auto"
            >
                <source
                    src="{{
                        item?.layoutContent?.banner?.video +
                            this.mediaCDN.getVideoCDN()
                    }}"
                    type="video/webm"
                />
                <source
                    [src]="
                        homepageService.convertWebToMp4(
                            item?.layoutContent?.banner?.video
                        )
                    "
                    type="video/mp4"
                />
            </video>
            <div
                *ngIf="!!item?.layoutContent?.button?.link"
                class="offer-strip__text-button"
                ngClass.xs="offer-strip__text-button-mobile"
                fxLayout="row"
                fxLayout.xs="column"
            >
                <div
                    class="offer-strip__container"
                    ngClass.lt-md="offer-strip__container-mobile"
                    [fxFlex]="homepageService.getFlex(item.layoutContent)"
                    [fxFlexOrder]="
                        homepageService.getFlexOrder(item.layoutContent)
                    "
                    fxLayout="column"
                    fxLayoutAlign="center flex-start"
                >
                    <h1
                        class="offer-strip__text-header"
                        style="color:{{ item?.layoutContent?.title?.color }}"
                        [ngStyle.lt-md]="{ fontSize: '18px' }"
                        >{{ item?.layoutContent?.title?.text }}</h1
                    >
                    <p
                        class="offer-strip__text-subtitle"
                        style="color:{{
                            item?.layoutContent?.subtitle?.color
                        }};white-space: pre-line"
                        [ngStyle.lt-md]="{ fontSize: '11px' }"
                        [ngStyle.gt-xs]="{ width: '150%' }"
                        >{{ item?.layoutContent?.subtitle?.text }}</p
                    >
                    <div style="border: 0.3px solid white; margin-left: 7px">
                        <button
                            class="offer-strip__button"
                            mat-raised-button
                            style="color:{{
                                item?.layoutContent?.button?.title?.color
                            }}"
                            >{{ item?.layoutContent?.button?.title?.text
                            }}<img
                                style="width: 12px; height: 12px"
                                src="{{ item?.layoutContent?.button?.icon }}"
                                appImageCDN
                                [alt]="
                                    item?.layoutContent?.title?.text || 'banner'
                                "
                        /></button>
                    </div>
                </div>
                <div #spacer fxFlex="0 1 50%" fxFlexOrder="0"></div>
            </div>
        </div>
        <div
            *ngIf="item?.layoutType === '1-col-offer-h131-strip-banner'"
            class="offer-extra-container"
            [ngStyle]="{
                paddingBottom: item?.layoutContent?.padding?.bottom + 'px',
                paddingTop: item?.layoutContent?.padding?.top + 'px'
            }"
            (click)="
                item?.layoutContent?.banner.link.includes('http://')
                    ? externalLinksRedirect(item?.layoutContent?.banner.link)
                    : processLink(item?.layoutContent?.banner.link)
            "
        >
            <picture
                class="offer-extra-strip"
                *ngIf="!item?.layoutContent?.banner?.video"
                [ngClass]="{ 'image-offer-shimmer': showShimmer }"
            >
                <img
                    class="offer-extra-strip__image"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>
            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{ item?.layoutContent?.banner?.image }}"
                style="
                    border: none;
                    position: absolute;
                    top: 0;
                    height: auto;
                    width: 100%;
                "
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
                preload="auto"
            >
                <source
                    src="{{
                        item?.layoutContent?.banner?.video +
                            this.mediaCDN.getVideoCDN()
                    }}"
                    type="video/webm"
                />
                <source
                    [src]="
                        homepageService.convertWebToMp4(
                            item?.layoutContent?.banner?.video
                        )
                    "
                    type="video/mp4"
                />
            </video>
        </div>
        <div
            *ngIf="item?.layoutType === '1-col-offer-h131-strip-banner-video'"
            class="offer-extra-container"
            [ngStyle.xs]="{ paddingTop: '0%' }"
            (click)="
                item?.layoutContent?.banner.link.includes('http://')
                    ? externalLinksRedirect(item?.layoutContent?.banner.link)
                    : processLink(item?.layoutContent?.banner.link)
            "
        >
            <picture
                class="offer-extra-strip"
                *ngIf="!item?.layoutContent?.banner?.video"
                [ngClass]="{ 'image-offer-shimmer': showShimmer }"
            >
                <img
                    class="offer-extra-strip__image"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>
            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{ item?.layoutContent?.banner?.image }}"
                style="border: none; height: auto; width: 100%"
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
                preload="auto"
            >
                <source
                    src="{{
                        item?.layoutContent?.banner?.video +
                            this.mediaCDN.getVideoCDN()
                    }}"
                    type="video/webm"
                />
                <source
                    [src]="
                        homepageService.convertWebToMp4(
                            item?.layoutContent?.banner?.video
                        )
                    "
                    type="video/mp4"
                />
            </video>
        </div>
        <div
            *ngIf="item.layoutType === '1-col-banner'"
            class="one-col-banner one-col-banner-mobile"
            ngClass.gt-xs="one-col-banner-desktop"
        >
            <picture
                class="one-col-banner-image"
                *ngIf="!item?.layoutContent?.banner?.video"
                [ngClass]="{ 'image-banner-shimmer': showShimmer }"
            >
                <img
                    class="image-holder"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>
            <!--Video-->
            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{
                    item?.layoutContent?.banner?.image + posterImageCDN
                }}"
                style="
                    clip-path: inset(0px);
                    border: none;
                    position: absolute;
                    top: 0;
                    height: auto;
                    width: 100%;
                "
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
                preload="auto"
            >
                <source
                    src="{{
                        item?.layoutContent?.banner?.video +
                            this.mediaCDN.getVideoCDN()
                    }}"
                    type="video/webm"
                />
                <source
                    [src]="
                        homepageService.convertWebToMp4(
                            item?.layoutContent?.banner?.video
                        )
                    "
                    type="video/mp4"
                />
            </video>
            <a
                [routerLink]="[
                    item?.layoutContent?.banner?.link | pageIdFromLink
                ]"
                [queryParams]="
                    item?.layoutContent?.banner?.link | queryParamFromLink
                "
                [attr.aria-label]="
                    item?.layoutContent?.title?.text || 'one-col-banner-link'
                "
            >
                <div
                    class="one-col-banner-content"
                    fxLayout="column"
                    fxLayout.gt-xs="row"
                >
                    <div
                        [fxFlex]="homepageService.getFlex(item.layoutContent)"
                        [fxFlexOrder]="
                            homepageService.getFlexOrder(item.layoutContent)
                        "
                        fxLayout="column"
                        [fxLayoutAlign]="
                            homepageService.getFlexAlign(item.layoutContent)
                        "
                        [ngStyle.gt-xs]="
                            item?.layoutContent?.title?.text &&
                            item?.layoutContent?.button?.title?.text
                                ? {
                                      padding: homepageService.isAlignmentValid(
                                          item?.layoutContent?.alignment
                                      )
                                  }
                                : null
                        "
                        [ngStyle.xs]="
                            item?.layoutContent?.title?.text &&
                            item?.layoutContent?.button?.title?.text
                                ? { padding: '24px' }
                                : null
                        "
                    >
                        <h1
                            class="banner-heading"
                            [ngClass.lt-md]="{ 'mob-banner-heading': true }"
                            style="color:{{
                                item?.layoutContent?.title?.color
                            }}"
                        >
                            {{ item?.layoutContent?.title?.text }}
                        </h1>
                        <p
                            *ngIf="item?.layoutContent?.subtitle?.text"
                            fxShow.xs="false"
                            style="font-family:'Roboto Regular'; font-size: 16px; font-style: normal; font-weight: 400; line-height: 24px; margin:0 0 12px 0; color: {{
                                item?.layoutContent?.subtitle?.color
                            }}"
                            [innerHTML]="
                                item?.layoutContent?.subtitle?.text | lineBreak
                            "
                        ></p>
                        <button
                            mat-flat-button
                            class="button-v2"
                            style="background: {{
                                item?.layoutContent?.button?.background?.color
                            }};
                            color:{{
                                item?.layoutContent?.button?.title?.color
                            }}"
                            *ngIf="!!item?.layoutContent?.button"
                            (click)="
                                processLink(item?.layoutContent?.button?.link)
                            "
                        >
                            {{ item?.layoutContent?.button?.title?.text }}
                        </button>
                    </div>
                    <div #spacer fxFlex="0 1 60%" fxFlexOrder="0"></div>
                </div>
            </a>
        </div>
        <div
            *ngIf="item.layoutType === '1-col-banner-without-padding'"
            class="one-col-banner-without-padding one-col-banner-mobile"
            ngClass.gt-xs="one-col-banner-desktop"
        >
            <picture
                class="one-col-banner-image"
                *ngIf="!item?.layoutContent?.banner?.video"
                [ngClass]="{ 'image-banner-shimmer': showShimmer }"
            >
                <img
                    class="image-holder"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>
            <!--Video-->
            <video
                *ngIf="item?.layoutContent?.banner?.video"
                poster="{{ item?.layoutContent?.banner?.image }}"
                style="
                    border: none;
                    position: absolute;
                    top: 0;
                    height: auto;
                    width: 100%;
                "
                loop
                muted
                autoplay
                oncanplay="this.play()"
                onloadedmetadata="this.muted = true"
                playsinline
                webkit-playsinline
                preload="auto"
            >
                <source
                    src="{{
                        item?.layoutContent?.banner?.video +
                            this.mediaCDN.getVideoCDN()
                    }}"
                    type="video/webm"
                />
                <source
                    [src]="
                        homepageService.convertWebToMp4(
                            item?.layoutContent?.banner?.video
                        )
                    "
                    type="video/mp4"
                />
            </video>
            <a
                [routerLink]="[
                    item?.layoutContent?.banner?.link | pageIdFromLink
                ]"
                [queryParams]="
                    item?.layoutContent?.banner?.link | queryParamFromLink
                "
                [attr.aria-label]="
                    item?.layoutContent?.title?.text || 'one-col-banner-link'
                "
            >
                <div
                    class="one-col-banner-content"
                    fxLayout="column"
                    fxLayout.gt-xs="row"
                >
                    <div
                        [fxFlex]="homepageService.getFlex(item.layoutContent)"
                        [fxFlexOrder]="
                            homepageService.getFlexOrder(item.layoutContent)
                        "
                        fxLayout="column"
                        [fxLayoutAlign]="
                            homepageService.getFlexAlign(item.layoutContent)
                        "
                        [ngStyle.gt-xs]="
                            item?.layoutContent?.title?.text &&
                            item?.layoutContent?.button?.title?.text
                                ? {
                                      padding: homepageService.isAlignmentValid(
                                          item?.layoutContent?.alignment
                                      )
                                  }
                                : null
                        "
                        [ngStyle.xs]="
                            item?.layoutContent?.title?.text &&
                            item?.layoutContent?.button?.title?.text
                                ? { padding: '24px' }
                                : null
                        "
                    >
                        <h1
                            class="banner-heading"
                            [ngClass.lt-md]="{ 'mob-banner-heading': true }"
                            style="color:{{
                                item?.layoutContent?.title?.color
                            }}"
                        >
                            {{ item?.layoutContent?.title?.text }}
                        </h1>
                        <p
                            *ngIf="item?.layoutContent?.subtitle?.text"
                            fxShow.xs="false"
                            style="font-family:'Roboto Regular'; font-size: 16px; font-style: normal; font-weight: 400; line-height: 24px; margin:0 0 12px 0; color: {{
                                item?.layoutContent?.subtitle?.color
                            }}"
                            [innerHTML]="
                                item?.layoutContent?.subtitle?.text | lineBreak
                            "
                        ></p>
                        <button
                            mat-flat-button
                            class="button-v2"
                            style="background: {{
                                item?.layoutContent?.button?.background?.color
                            }};
                            color:{{
                                item?.layoutContent?.button?.title?.color
                            }}"
                            *ngIf="!!item?.layoutContent?.button"
                            (click)="
                                processLink(item?.layoutContent?.button?.link)
                            "
                        >
                            {{ item?.layoutContent?.button?.title?.text }}
                        </button>
                    </div>
                    <div #spacer fxFlex="0 1 60%" fxFlexOrder="0"></div>
                </div>
            </a>
        </div>
        <div
            *ngIf="item.layoutType === 'slider-with-subtext'"
            class="slider-with-button"
            ngClass.xs="slider-with-button-mobile"
            fxLayout="column"
            fxLayoutAlign="center"
            [ngStyle.gt-xs]="{ paddingLeft: '19px' }"
        >
            <h2
                class="slider-with-button__header"
                ngClass.gt-xs="slider-with-button__desktop-header"
                style="color:{{ item?.layoutContent?.title?.color }}"
                >{{ item?.layoutContent?.title?.text }}</h2
            >
            <div
                fxLayout="row"
                fxLayoutAlign="flex-start"
                style="overflow-x: auto; margin-left: 17px"
                ngClass.xs="scrollBar-v2"
                ngClass.gt-xs="scrollBar"
            >
                <div
                    fxLayout="column"
                    ngClass.gt-xs="slider-with-banner"
                    *ngFor="let slide of item?.layoutContent?.slider"
                    [ngClass]="{ 'image-slider-shimmer': showShimmer }"
                    fxFlex.gt-xs="0 0 22%"
                    fxFlex.xs="0 0 42%"
                    [ngStyle.gt-xs]="{ paddingRight: '44px' }"
                    [ngStyle.xs]="{ paddingRight: '13px' }"
                >
                    <a
                        class="anchor-tag"
                        [routerLink]="[slide?.banner?.link | pageIdFromLink]"
                        [queryParams]="slide?.banner?.link | queryParamFromLink"
                        [attr.aria-label]="slide?.title?.text || 'banner-link'"
                    >
                        <picture
                            class="slider-with-banner-image"
                            ngClass.xs="{slider-with-banner-image__mobile}"
                        >
                            <img
                                class="slider-with-banner-image-holder"
                                src="{{ slide?.banner?.image }}"
                                appImageCDN
                                [alt]="slide?.title?.text || 'banner'"
                            />
                        </picture>
                        <div
                            style=" background:#{{
                                item?.layoutContent?.banner?.scrim?.color +
                                    item?.layoutContent?.banner?.scrim?.alpha
                            }}"
                            class="slider-with-button-content"
                            fxLayout="column"
                            fxLayoutAlign="center flex-start"
                        >
                            <h1
                                class="slider-with-button-content__header"
                                ngClass.gt-xs="slider-with-button-content__desktop-header"
                                style="color: black; text-align: left"
                            >
                                {{ slide?.title?.text }}
                            </h1>
                        </div>
                    </a>
                </div>
            </div>
            <div
                fxLayout="column"
                *ngIf="!!item?.layoutContent?.button?.title?.text"
            >
                <button
                    (click)="processLink(item?.layoutContent?.button?.link)"
                    mat-flat-button
                    class="primary mob-button"
                    style="margin: 58px auto 80px;margin-bottom: 0;background:{{
                        item?.layoutContent?.button?.background?.color
                    }};color:{{ item?.layoutContent?.button?.title?.color }}"
                >
                    {{ item?.layoutContent?.button?.title?.text }}
                </button>
            </div>
        </div>

        <div
            *ngIf="item.layoutType === 'slider-with-subtext-v2'"
            class="slider-with-button"
            ngClass.xs="slider-with-button-mobile"
            fxLayout="column"
            fxLayoutAlign="center"
            [ngStyle.gt-xs]="{ paddingLeft: '19px' }"
        >
            <div
                fxLayoutAlign="space-between"
                [ngStyle.xs]="{
                    marginBottom: '16px',
                    marginRight: '16px'
                }"
            >
                <h2
                    *ngIf="item?.layoutContent?.title?.text"
                    class="slider-with-button__header"
                    ngClass.gt-xs="slider-with-button__desktop-header"
                    style="color:{{
                        item?.layoutContent?.title?.color
                    }}; margin-bottom: 0px"
                    >{{ item?.layoutContent?.title?.text }}</h2
                >
                <button
                    *ngIf="item?.layoutContent?.button?.title?.text"
                    fxShow.gt-xs="true"
                    fxShow.xs="true"
                    class="view-button"
                    (click)="processLink(item?.layoutContent?.button?.link)"
                    style="color: {{
                        item?.layoutContent?.button?.title?.color
                    }}"
                    >{{ item?.layoutContent?.button?.title?.text }}</button
                >
            </div>
            <div
                fxLayout="row"
                fxLayoutAlign="flex-start"
                style="overflow-x: auto; margin-left: 16px"
                ngClass.xs="scrollBar-v2"
                ngClass.gt-xs="scrollBar"
            >
                <div
                    fxLayout="column"
                    ngClass.gt-xs="slider-with-banner"
                    *ngFor="let slide of item?.layoutContent?.slider"
                    [ngClass]="{ 'image-slider-shimmer': showShimmer }"
                    fxFlex.gt-xs="0 0 22%"
                    fxFlex.xs="0 0 42%"
                    [ngStyle.gt-xs]="{ paddingRight: '44px' }"
                    [ngStyle.xs]="{
                        paddingRight: '13px',
                        marginBottom: iosWeb ? '0' : '20px'
                    }"
                >
                    <a
                        class="anchor-tag"
                        [routerLink]="[slide?.banner?.link | pageIdFromLink]"
                        [queryParams]="slide?.banner?.link | queryParamFromLink"
                        [attr.aria-label]="slide?.title?.text || 'banner-link'"
                    >
                        <picture
                            class="slider-with-banner-image"
                            ngClass.xs="{slider-with-banner-image__mobile}"
                        >
                            <img
                                class="slider-with-banner-image-holder"
                                [ngStyle.xs]="{
                                    marginBottom: '12px'
                                }"
                                src="{{ slide?.banner?.image }}"
                                appImageCDN
                                [alt]="slide?.title?.text || 'banner'"
                            />
                        </picture>
                        <div
                            style=" background:#{{
                                item?.layoutContent?.banner?.scrim?.color +
                                    item?.layoutContent?.banner?.scrim?.alpha
                            }}"
                            class="slider-with-button-content"
                            fxLayout="column"
                            fxLayoutAlign="center flex-start"
                        >
                            <span
                                *ngIf="slide.subtitle"
                                style="text-align: left; margin-bottom: 7px; font-size: 13px; color: {{
                                    slide.subtitle.color
                                }}"
                                [ngStyle.xs]="{
                                    marginBottom: '5px',
                                    fontSize: '12px'
                                }"
                            >
                                {{ slide?.subtitle?.text }}
                            </span>
                            <h1
                                *ngIf="slide.title"
                                class="slider-title-v2"
                                style="text-align: left; font-size: 16px; color: {{
                                    slide.title.color
                                }}"
                                [ngStyle.xs]="{
                                    fontSize: '13px',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    width: '100%'
                                }"
                            >
                                {{ slide?.title?.text }}
                            </h1>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <div *ngIf="item?.layoutType === '2-col-slider'">
            <div fxLayout="row" style="margin: 0 38px 56px 38px">
                <div
                    fxLayout="column"
                    fxLayoutAlign="center"
                    style="margin: 0 54px; width: 25%"
                >
                    <span class="two-col-slider-title">{{
                        item?.layoutContent?.title?.text.split(' ')[0]
                    }}</span>
                    <span class="two-col-slider-title">{{
                        item?.layoutContent?.title?.text
                            .replace(
                                item?.layoutContent?.title?.text.split(' ')[0],
                                ''
                            )
                            .trim()
                    }}</span>
                    <span class="two-col-slider-subtitle">{{
                        item?.layoutContent?.subtitle?.text
                    }}</span>
                    <button
                        *ngIf="item?.layoutContent?.button"
                        class="flat-no-border-black-button"
                        style="color: {{
                            item?.layoutContent?.button?.title?.color
                        }}"
                        (click)="processLink(item?.layoutContent?.button?.link)"
                        >{{ item?.layoutContent?.button?.title?.text }}</button
                    >
                </div>

                <swiper
                    style="width: 75%"
                    [slidesPerView]="4"
                    [slidesPerGroup]="4"
                    [speed]="1300"
                    [navigation]="true"
                    [spaceBetween]="20"
                    [effect]="'flip'"
                    (swiper)="homepageService.onSwiper($event)"
                    (slideChange)="homepageService.onSlideChange($event)"
                >
                    <ng-template
                        swiperSlide
                        *ngFor="let feedItem of item?.layoutContent?.slider"
                    >
                        <picture>
                            <img
                                style="width: 100%; cursor: pointer"
                                (click)="processLink(feedItem?.banner?.link)"
                                src="{{ feedItem?.banner?.image }}"
                                appImageCDN
                                [alt]="feedItem?.title?.text || 'banner'"
                            />
                        </picture>
                        <div fxLayout="column">
                            <span
                                *ngIf="feedItem.subtitle"
                                class="slider-subtitle"
                                style="color: {{ feedItem.subtitle.color }}"
                                [ngStyle.xs]="{
                                    marginBottom: '5px',
                                    fontSize: '12px'
                                }"
                            >
                                {{ feedItem?.subtitle?.text }}
                            </span>
                            <h1
                                *ngIf="feedItem.title"
                                class="slider-title"
                                [ngStyle]="{
                                    marginTop: feedItem?.subtitle?.text
                                        ? ''
                                        : '6px'
                                }"
                            >
                                {{ feedItem?.title?.text }}
                            </h1>
                        </div>
                    </ng-template>
                </swiper>
            </div>
        </div>

        <div
            fxLayout="column"
            class="two-col-banner"
            *ngIf="item.layoutType === 'two-col-banner'"
            ngClass.xs="two-col-banner__mobile"
        >
            <h1
                *ngIf="item?.layoutContent?.title?.text"
                class="two-col-banner__header"
                ngClass.gt-xs="two-col-banner__desktop-header"
                style="color:{{ item?.layoutContent?.title?.color }}"
                >{{ item?.layoutContent?.title?.text }}</h1
            >
            <div
                fxLayout="column"
                fxLayout.gt-xs="row"
                fxLayoutAlign="space-between"
                fxLayoutGap.gt-xs="36px"
                [ngStyle.gt-xs]="{ height: '32vw', width: '100%' }"
            >
                <div
                    class="two-col-banner-holder"
                    *ngFor="let feed of item?.layoutContent?.feed"
                    fxFlex.xs="0 0 100%"
                    fxFlex.gt-xs="0 0 calc( 50% - 18px)"
                    (click)="processLink(feed?.button?.link)"
                >
                    <picture
                        class="two-col-banner-image"
                        (click)="processLink(feed?.banner?.link)"
                    >
                        <img
                            class="two-col-banner-image__banner"
                            src="{{ feed?.banner?.image }}"
                            appImageCDN
                            [alt]="feed?.title?.text || 'banner'"
                        />
                    </picture>

                    <div
                        class="two-col-banner__text-and-button"
                        ngClass.xs="two-col-banner__text-and-button-mob"
                    >
                        <h1
                            class="two-col-banner__heading"
                            [ngStyle.lt-md]="{
                                'font-size': '12px',
                                marginBottom: '11px'
                            }"
                            style="color:{{ feed?.title?.color }}"
                            >{{ feed?.title?.text }}</h1
                        >
                        <button
                            mat-flat-button
                            class="button-text two-col-banner__button"
                            [ngClass.lt-md]="{
                                'two-col-banner__button-mob': true
                            }"
                            style="background:{{
                                feed?.button?.background?.color
                            }};color:{{ feed?.button?.title?.color }}"
                        >
                            {{ feed?.button?.title?.text }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            *ngIf="item?.layoutType === 'two-col-banner-2'"
            ngClass.gt-xs="two-col-banner-2__desktop-margin"
            ngClass.xs="two-col-banner-2__mobile-margin"
        >
            <h1
                *ngIf="item?.layoutContent?.title?.text"
                class="two-col-banner__header"
                ngClass.gt-xs="two-col-banner__desktop-header"
                style="color:{{ item?.layoutContent?.title?.color }}"
                >{{ item?.layoutContent?.title?.text }}</h1
            >
            <div
                fxLayout.gt-xs="row"
                fxLayout.xs="column"
                fxLayoutAlign="space-between"
            >
                <div
                    fxFlex="0 0 48.5%"
                    fxFlex.xs="0 0 100%"
                    fxLayout="column"
                    *ngFor="let feedData of item?.layoutContent?.feed"
                >
                    <img
                        style="margin-bottom: 8px; width: 100%"
                        [ngStyle.xs]="{ marginBottom: '5px' }"
                        src="{{ feedData?.banner?.image }}"
                        (click)="processLink(feedData?.banner?.link)"
                        appImageCDN
                        [alt]="feedData?.title?.text || 'banner'"
                    />
                    <span
                        class="two-col-banner-2__title"
                        ngClass.xs="two-col-banner-2__title__mobile"
                        >{{ feedData?.title?.text }}</span
                    >
                    <button
                        class="two-col-banner-2__button"
                        ngClass.xs="two-col-banner-2__button-mobile"
                        mat-flat-button
                        color="primary"
                        (click)="processLink(feedData?.button?.link)"
                    >
                        {{ feedData?.button?.title?.text }}
                    </button>
                </div>
            </div>
        </div>

        <div
            *ngIf="item?.layoutType === 'two-col-banner-3'"
            ngClass.gt-xs="two-col-banner-3__desktop-margin"
            ngClass.xs="two-col-banner-3__mobile-margin"
        >
            <h1
                *ngIf="item?.layoutContent?.title?.text"
                class="two-col-banner__header"
                ngClass.gt-xs="two-col-banner__desktop-header"
                style="color:{{ item?.layoutContent?.title?.color }}"
                >{{ item?.layoutContent?.title?.text }}</h1
            >
            <div
                fxLayout.gt-xs="row"
                fxLayout.xs="column"
                fxLayoutAlign="space-between"
                fxLayoutGap.xs="35px"
            >
                <div
                    fxFlex="0 0 48.5%"
                    fxFlex.xs="0 0 100%"
                    fxLayout="column"
                    *ngFor="let feedData of item?.layoutContent?.feed"
                >
                    <a
                        *ngIf="feedData?.banner?.image"
                        [routerLink]="[feedData?.banner?.link | pageIdFromLink]"
                        [queryParams]="
                            feedData?.banner?.link | queryParamFromLink
                        "
                        [attr.aria-label]="
                            feedData?.title?.text || 'banner-link'
                        "
                    >
                        <img
                            style="margin-bottom: 8px; width: 100%"
                            [ngStyle.xs]="{ marginBottom: '5px' }"
                            src="{{ feedData?.banner?.image }}"
                            appImageCDN
                            [alt]="feedData?.title?.text || 'banner'"
                        />
                    </a>
                    <span
                        class="two-col-banner-3__title"
                        ngClass.xs="two-col-banner-3__title__mobile"
                        >{{ feedData?.title?.text }}</span
                    >
                    <span
                        class="underline-action-button"
                        style="cursor: pointer"
                        [ngStyle.xs]="{
                            fontSize: '13px'
                        }"
                        (click)="processLink(feedData?.button?.link)"
                        >{{ feedData?.button?.title?.text }}</span
                    >
                </div>
            </div>
        </div>

        <div
            fxShow="false"
            fxShow.lt-md="true"
            *ngIf="item.layoutType === '2-col-slider-with-banner'"
            fxLayout="column"
            fxLayoutGap="15px"
            fxLayoutAlign="center"
            style="background:{{ item?.layoutContent?.meta?.background }}"
        >
            <h1
                fxLayout="row"
                fxLayoutAlign="center center"
                style="font-size: 32px"
            >
                {{ item?.layoutContent?.title?.text }}
            </h1>
            <div
                fxLayout="row"
                fxLayoutGap="6vw"
                fxLayoutAlign="flex-start"
                style="overflow-x: scroll"
            >
                <img
                    (click)="processLink(slider?.banner?.link)"
                    *ngFor="let slider of item?.layoutContent?.slider"
                    class="mob-image-slider"
                    src="{{ slider?.banner?.image }}"
                    appImageCDN
                    [alt]="slider?.title?.text || 'banner'"
                />
            </div>

            <div fxLayout="row">
                <picture
                    fxLayout
                    fxLayoutAlign="center center"
                    style="width: 100%; position: relative"
                    (click)="
                        processLink(item?.layoutContent?.banner?.banner?.link)
                    "
                >
                    <img
                        class="mob-image-slider-banner"
                        src="{{ item?.layoutContent?.banner?.banner?.image }}"
                        appImageCDN
                        [alt]="item?.layoutContent?.title?.text || 'banner'"
                    />
                    <h1
                        style="font-size: 24px;position: absolute;
                     left: 50%;
                      bottom: 50%;
                      transform: translate(-50%, -50%);
                      color:{{ item?.layoutContent?.banner?.title?.color }}"
                    >
                        {{ item?.layoutContent?.banner?.title?.text }}
                    </h1>
                </picture>
            </div>

            <div fxLayout="column">
                <button
                    mat-flat-button
                    class="button-text-medium mob-button"
                    style="margin: 34px auto 57px;background:{{
                        item?.layoutContent?.button?.background?.color
                    }};color:{{ item?.layoutContent?.button?.title?.color }}"
                >
                    {{ item?.layoutContent?.button?.title?.text }}
                </button>
            </div>
        </div>
        <div
            *ngIf="item.layoutType === 'banner-text-description'"
            class="banner-text-description-mobile"
            [ngClass.gt-xs]="{
                'banner-text-description': true,
                'banner-text-description-mobile': false
            }"
            fxLayout="column-reverse"
            fxLayout.gt-xs="row"
        >
            <div
                class="banner-text-description__content"
                fxLayout="column"
                fxLayoutAlign="center"
                style=" background:#{{
                    item?.layoutContent?.banner?.scrim?.color +
                        item?.layoutContent?.banner?.scrim?.alpha
                }}"
                [ngStyle.gt-xs]="{ width: '39%', margin: '0 16px' }"
                [ngStyle.xs]="{ width: '100%' }"
            >
                <h1
                    fxLayout="column"
                    fxLayoutAlign="none flex-start"
                    class="banner-text-description__header"
                    [ngClass.lt-md]="{
                        'banner-text-description__header': false,
                        'banner-text-description-mobile__header': true
                    }"
                    style="color:{{ item?.layoutContent?.title?.color }}"
                >
                    {{ item?.layoutContent?.title?.text }}
                </h1>
                <div
                    *ngIf="item?.layoutContent?.description"
                    style="display: flex; flex-direction: column; gap: 16px"
                    [ngStyle.gt-xs]="{ marginBottom: '24px' }"
                    [ngStyle.xs]="{ marginBottom: '16px' }"
                >
                    <p
                        [ngStyle.gt-xs]="{
                            fontFamily: 'Roboto Regular',
                            fontSize: '18px',
                            fontWeight: '400',
                            lineHeight: '28px',
                            textAlign: 'left'
                        }"
                        [ngStyle.xs]="{
                            fontFamily: 'Roboto Regular',
                            fontSize: '16px',
                            fontWeight: '400',
                            lineHeight: '22px',
                            textAlign: 'left'
                        }"
                        *ngFor="let subtext of item?.layoutContent?.description"
                        >{{ subtext }}</p
                    >
                </div>
                <span
                    *ngIf="
                        !!item?.layoutContent?.button?.title?.text &&
                        item?.layoutContent?.button?.buttonLayout !==
                            'secondary'
                    "
                    class="underline-action-button-2"
                    style="cursor: pointer; margin-top: 16px"
                    [ngStyle.xs]="{
                        fontSize: '13px'
                    }"
                    (click)="processLink(item?.layoutContent?.banner?.link)"
                    >{{ item?.layoutContent?.button?.title?.text }}</span
                >
                <a
                    *ngIf="item?.layoutContent?.button?.title?.text"
                    [routerLink]="[
                        item?.layoutContent?.button?.link | pageIdFromLink
                    ]"
                    [queryParams]="
                        item?.layoutContent?.button?.link | queryParamFromLink
                    "
                    style="text-decoration: none"
                    [attr.aria-label]="
                        item?.layoutContent?.title?.text || 'banner-link'
                    "
                >
                    <button
                        mat-flat-button
                        class="button-v2"
                        style="background: {{
                            item?.layoutContent?.button?.background?.color
                        }};
                    color:{{ item?.layoutContent?.button?.title?.color }}"
                        *ngIf="
                            item?.layoutContent?.button?.buttonLayout ===
                                'secondary' &&
                            !!item?.layoutContent?.button?.title?.text
                        "
                    >
                        {{ item?.layoutContent?.button?.title?.text }}
                    </button>
                </a>
            </div>
            <picture
                class="banner-text-description__image"
                [ngStyle.gt-xs]="{ width: '44.64%' }"
                [ngStyle.xs]="{ width: '100%', 'margin-bottom': '24px' }"
            >
                <img
                    class="image-holder"
                    src="{{ item?.layoutContent?.banner?.image }}"
                    appImageCDN
                    [alt]="item?.layoutContent?.title?.text || 'banner'"
                />
            </picture>
        </div>

        <div *ngIf="item.layoutType === 'collections-banner'">
            <div
                *ngIf="item?.layoutContent?.slider?.length > 0"
                style="margin: 0 0 56px 34px"
                [ngStyle.xs]="{ margin: '0 0 35px 19px' }"
            >
                <div
                    fxLayoutAlign="space-between"
                    style="margin-bottom: 24px; margin-right: 34px"
                    [ngStyle.xs]="{
                        marginBottom: '10px',
                        marginRight: '19px'
                    }"
                >
                    <span
                        class="collections-banner-title"
                        ngClass.xs="collections-banner-title__mobile"
                        style="color:{{ item?.layoutContent?.title?.color }}"
                        >{{ item?.layoutContent?.title?.text }}</span
                    >
                    <button
                        fxShow.gt-xs="true"
                        fxShow.xs="true"
                        class="view-button"
                        (click)="processLink(item?.layoutContent?.button?.link)"
                        style="color: {{
                            item?.layoutContent?.button?.title?.color
                        }}"
                        >{{ item?.layoutContent?.button?.title?.text }}</button
                    >
                </div>
                <div
                    fxLayout.gt-xs="row wrap"
                    fxLayout.xs="row"
                    fxLayoutGap="1%"
                    [ngStyle.xs]="{
                        overflowX: 'auto'
                    }"
                >
                    <div
                        *ngFor="let feedItem of item?.layoutContent?.slider"
                        fxFlex="32%"
                        fxLayout="column"
                        ngClass.xs="collections-banner-picture"
                        fxFlex.xs="0 0 76%"
                        style="min-height: 487px"
                    >
                        <picture>
                            <img
                                style="width: 100%; cursor: pointer"
                                [ngStyle.gt-xs]="{ marginBottom: '7px' }"
                                [ngStyle.xs]="{ marginBottom: '8px' }"
                                src="{{ feedItem?.banner?.image }}"
                                (click)="processLink(feedItem?.banner?.link)"
                                appImageCDN
                                [alt]="
                                    item?.layoutContent?.title?.text || 'banner'
                                "
                            />
                        </picture>
                        <span
                            *ngIf="feedItem?.title?.text"
                            class="collection-with-text__title"
                            style="color: {{ feedItem?.title?.color }}"
                            [ngStyle.xs]="{
                                fontSize: '16px',
                                marginBottom: '5px'
                            }"
                        >
                            {{ feedItem?.title?.text }}
                        </span>
                        <span
                            *ngIf="feedItem?.subtitle?.text"
                            class="collection-with-text__subtitle"
                            style="color: {{ feedItem?.subtitle?.color }}"
                            [ngStyle.xs]="{
                                fontSize: '13px',
                                marginBottom: '11px'
                            }"
                            >{{ feedItem?.subtitle?.text }}</span
                        >
                        <span
                            *ngIf="feedItem?.button?.title?.text"
                            class="underline-action-button"
                            style="cursor: pointer"
                            [ngStyle.xs]="{
                                fontSize: '13px'
                            }"
                            (click)="processLink(feedItem?.button?.link)"
                            >{{ feedItem?.button?.title?.text }}</span
                        >
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="item.layoutType === 'collections-banner-with-text'">
            <div
                *ngIf="item?.layoutContent?.slider?.length > 0"
                style="margin: 0 0 56px 34px"
                [ngStyle.xs]="{ margin: '0 0 35px 19px' }"
            >
                <div
                    fxLayoutAlign="space-between"
                    style="margin-bottom: 24px; margin-right: 34px"
                    [ngStyle.xs]="{ marginBottom: '10px' }"
                >
                    <span
                        class="collections-banner-with-text-title"
                        ngClass.xs="collections-banner-with-text-title__mobile"
                        style="color:{{ item?.layoutContent?.title?.color }}"
                        >{{ item?.layoutContent?.title?.text }}</span
                    >
                    <button
                        class="view-button"
                        (click)="processLink(item?.layoutContent?.button?.link)"
                        style="color: {{
                            item?.layoutContent?.button?.title?.color
                        }}"
                        >{{ item?.layoutContent?.button?.title?.text }}</button
                    >
                </div>
                <div
                    fxLayout.gt-xs="row wrap"
                    fxLayout.xs="column"
                    fxLayoutGap="1%"
                    fxLayoutGap.xs="35px"
                    [ngStyle.xs]="{
                        overflowX: 'auto'
                    }"
                >
                    <div
                        *ngFor="
                            let feedItem of item?.layoutContent?.slider;
                            let i = index
                        "
                        fxFlex="32%"
                        fxFlex.xs="0 0 100%"
                        fxLayout="column"
                        style="min-height: 487px"
                        [ngStyle.xs]="{
                            paddingRight: '20px'
                        }"
                    >
                        <picture>
                            <img
                                style="width: 100%; cursor: pointer"
                                [ngStyle.gt-xs]="{ marginBottom: '14px' }"
                                [ngStyle.xs]="{ marginBottom: '9px' }"
                                src="{{ feedItem?.banner?.image }}"
                                (click)="processLink(feedItem?.banner?.link)"
                                appImageCDN
                                [alt]="feedItem?.title?.text || 'banner'"
                            />
                        </picture>
                        <span
                            *ngIf="feedItem?.title?.text"
                            class="collection-with-text__title"
                            style="color: {{ feedItem?.title?.color }}"
                            [ngStyle.xs]="{
                                fontSize: '16px',
                                marginBottom: '5px'
                            }"
                        >
                            {{ feedItem?.title?.text }}
                        </span>
                        <span
                            *ngIf="feedItem?.subtitle?.text"
                            class="collection-with-text__subtitle"
                            style="color: {{ feedItem?.subtitle?.color }}"
                            [ngStyle.xs]="{
                                fontSize: '13px',
                                marginBottom: '11px'
                            }"
                            >{{ feedItem?.subtitle?.text }}</span
                        >
                        <span
                            *ngIf="feedItem?.button?.title?.text"
                            class="underline-action-button"
                            style="cursor: pointer"
                            [ngStyle.xs]="{
                                fontSize: '13px'
                            }"
                            (click)="processLink(feedItem?.button?.link)"
                            >{{ feedItem?.button?.title?.text }}</span
                        >
                    </div>
                </div>
            </div>
        </div>

        <div
            *ngIf="item?.layoutType === '1-col-carousel-banner'"
            class="one-col-carousel"
            ngClass.xs="one-col-carousel-mobile"
        >
            <swiper
                [virtual]="false"
                [navigation]="true"
                [autoplay]="true"
                [pagination]="{ clickable: true }"
                [slidesPerView]="1"
                [loop]="true"
                (swiper)="homepageService.onSwiper($event)"
            >
                <ng-template
                    *ngFor="let carouselImage of item?.layoutContent?.feed"
                    swiperSlide
                >
                    <div
                        class="
                            one-col-banner-carousel
                            one-col-banner-carousel-mobile
                        "
                        ngClass.gt-xs="one-col-banner-carousel-desktop"
                    >
                        <picture
                            class="one-col-banner-image"
                            [ngClass]="{
                                'image-banner-shimmer': showShimmer
                            }"
                        >
                            <img
                                src="{{ carouselImage?.banner?.image }}"
                                (click)="
                                    processLink(carouselImage?.banner?.link)
                                "
                                class="image-holder"
                                appImageCDN
                                [alt]="carouselImage?.title?.text || 'banner'"
                            />
                        </picture>
                        <a
                            [routerLink]="[
                                carouselImage?.banner?.link | pageIdFromLink
                            ]"
                            [queryParams]="
                                carouselImage?.banner?.link | queryParamFromLink
                            "
                            [attr.aria-label]="
                                carouselImage?.title?.text ||
                                'one-col-banner-link'
                            "
                        >
                            <div
                                class="one-col-banner-content"
                                fxLayout="column"
                                fxLayout.gt-xs="row"
                            >
                                <div
                                    [fxFlex]="
                                        homepageService.getFlex(carouselImage)
                                    "
                                    [fxFlexOrder]="
                                        homepageService.getFlexOrder(
                                            carouselImage
                                        )
                                    "
                                    fxLayout="column"
                                    fxLayoutAlign="center center"
                                >
                                    <h1
                                        class="banner-heading"
                                        [ngClass.lt-md]="{
                                            'mob-banner-heading': true
                                        }"
                                        style="color:{{
                                            carouselImage?.title?.color
                                        }}"
                                    >
                                        {{ carouselImage?.title?.text }}
                                    </h1>
                                    <button
                                        mat-flat-button
                                        class="mob-button"
                                        ngClass.gt-xs="desk-button"
                                        style="background: {{
                                            carouselImage?.button?.background
                                                ?.color
                                        }};color:{{
                                            carouselImage?.button?.title?.color
                                        }}"
                                        *ngIf="!!carouselImage?.button"
                                    >
                                        {{ carouselImage?.button?.title?.text }}
                                    </button>
                                </div>
                                <div
                                    #spacer
                                    fxFlex="0 1 60%"
                                    fxFlexOrder="0"
                                ></div>
                            </div>
                        </a>
                    </div>
                </ng-template>
            </swiper>
        </div>
        <app-carousel-banner-v3
            *ngIf="item?.layoutType === '1-col-carousel-banner-v3'"
            [item]="item"
            [showShimmer]="showShimmer"
            (emitLink)="processLink($event)"
        ></app-carousel-banner-v3>
        <app-two-col-banner-with-title-v2
            *ngIf="item?.layoutType === '2-col-banner-with-title-v2'"
            [item]="item"
            [showShimmer]="showShimmer"
            (emitLink)="processLink($event)"
        ></app-two-col-banner-with-title-v2>
        <app-collection-banner-v3
            *ngIf="item?.layoutType === 'collections-banner-v3'"
            [item]="item"
            [showShimmer]="showShimmer"
            (emitLink)="processLink($event)"
        ></app-collection-banner-v3>
        <app-slider-with-subtext-v4
            *ngIf="item?.layoutType === 'slider-with-subtext-v4'"
            [item]="item"
            [showShimmer]="showShimmer"
            (emitLink)="processLink($event)"
        ></app-slider-with-subtext-v4>
        <app-category-tab-section-v2
            *ngIf="item?.layoutType === 'category-tab-section-v2'"
            [item]="item"
            [showShimmer]="showShimmer"
        ></app-category-tab-section-v2>
        <app-one-col-banner-v2
            *ngIf="item?.layoutType === '1-col-banner-v3'"
            [item]="item"
            [showShimmer]="showShimmer"
            (emitLink)="processLink($event)"
        ></app-one-col-banner-v2>
        <app-home-page-v2
            [item]="item"
            [showShimmer]="showShimmer"
        ></app-home-page-v2>
    </div>
    <div
        *ngIf="!noDataLeft && nextPageLoading"
        style="height: 20px"
        (visibilityNotifier)="
            processLink('/fn/pagination?f=' + page + '&action=pagination')
        "
    >
    </div>
</div>
<app-social-carousel></app-social-carousel>
<app-footer-v2 [filter]="filters" [page]="'hp'"></app-footer-v2>
<button
    *ngIf="scrollTopButton"
    (click)="processLink('/fn/?action=scroll-to-top')"
    mat-fab
    class="button-round right-8"
    fxLayoutAlign="center center"
>
    <img
        class="lfp-icon button-top"
        src="https://images.dailyobjects.com/icons/right_arrow_black.png"
        alt="scroll-img"
    />
</button>

<mat-progress-spinner
    *ngIf="loading && !showShimmer"
    class="page-spinner"
    style="bottom: 25px"
    mode="indeterminate"
    diameter="40"
    strokeWidth="5"
    value="5"
></mat-progress-spinner>
<app-offer-toggle [page]="'hp'"></app-offer-toggle>
